import { colors } from "healthex-common/colors";
import styled, { css } from "styled-components";
import { FlexRow } from "./common.styles";
import { HXCheckbox } from "./base.styles";
import { LittleText } from "./HXMobilePage.styles";
export const HXPatientCheckboxContainer = styled(FlexRow) `
    gap: 12px;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    border: 1px solid ${colors.blue_30};
    transition: border 0.25s, background-color 0.25s;

    @media (hover: hover) {
        &:hover {
            border: 1px solid ${colors.navy_main};
        }
    }

    ${(props) => props.checked &&
    css `
            background-color: ${colors.blue_10};
        `}

    ${(props) => !props.checked &&
    css `
            @media (hover: hover) {
                &:hover {
                    background-color: ${colors.navy_4};
                }
            }
        `}

    ${(props) => props.isError &&
    css `
            border-color: ${colors.tulip_main};
        `}

    ${(props) => props.addRightPadding &&
    css `
            padding-right: 16px !important;
        `}
`;
export const HXPatientCheckboxControl = styled(HXCheckbox) `
    flex: 1 0 0;
    padding: 12px 0;
    min-height: ${(props) => { var _a; return (_a = props.minHeight) !== null && _a !== void 0 ? _a : 72; }}px;
    box-sizing: border-box;

    .MuiCheckbox-root {
        margin: 0px;
        padding: ${(props) => { var _a; return (_a = props.padding) !== null && _a !== void 0 ? _a : "12px 4px 12px 20px"; }};

        &:hover {
            background: transparent;
        }
    }

    &.MuiFormControlLabel-root {
        margin: 0px;
    }
`;
export const HXPatientCheckboxLabel = styled(LittleText).attrs({ grow: true }) `
    margin-left: 8px;
`;
